/* eslint-disable react/prop-types */
import React from "react"; //import the component part of React
//declare the component

const ClassCapacityWarning = (props) => {
  const remainingSpaces = props.Capacity - props.SubscribersNumber;

  if (remainingSpaces >= 3) {
    return (
      <div className='alert-green capacityWarning' role='alert'>
        <span>Spaces Available</span>
      </div>
    );
  } else if (remainingSpaces === 2) {
    return (
      <div className='alert-orange capacityWarning' role='alert'>
        <span>Limited Spaces</span>
      </div>
    );
  } else if (remainingSpaces === 1) {
    return (
      <div className='alert-danger capacityWarning' role='alert'>
        <span>One Space Left!</span>
      </div>
    );
  } else {
    return (
      <div className='alert-danger text-black capacityWarning' role='alert'>
        <span>Full</span>
      </div>
    );
  }
};

//export the component
export default ClassCapacityWarning;
